import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import './style.css';
import api from '../../services/api';
import { Row, Col } from 'react-bootstrap';
import AlertMessage from '../Alert';
import { useLocation } from 'react-router-dom';
import { NiveisAcesso } from '../../constants/niveisAcesso';

const DynamicTable = ({ type, headerColor, riscoSelecionado = null, tabelaSelecionada = null, selectedRisco = null, edit = null, fetchRiscosPorTabela, setShowModal, riscos = [] }: any) => {
    const [categoria, setCategoria] = useState('');
    const [risco, setRisco] = useState('');
    const [fonteGeradora, setFonteGeradora] = useState('');
    const [possiveisDanosASaude, setPossiveisDanosASaude] = useState('');
    const [probabilidade, setProbabilidade] = useState('');
    const [severidade, setSeveridade] = useState('');
    const [probabilidadePgr, setProbabilidadePgr] = useState('');
    const [severidadePgr, setSeveridadePgr] = useState('');
    const [medidasDeControlePropostas, setMedidasDeControlePropostas] = useState('');
    const [cronograma, setCronograma] = useState('');
    const [formasDeAcompanhamento, setFormasDeAcompanhamento] = useState('');
    const [afericaoDosResultados, setAfericaoDosResultados] = useState('');
    const [meiosPropagacao, setMeiosPropagacao] = useState('');
    const [frequencia, setFrequencia] = useState('');
    const [medidasDeControleExistentes, setMedidasDeControleExistentes] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [quarentenaRiscosEditados, setQuarentenaRiscosEditados] = useState([]);
    const [grauDeRisco, setGrauDeRisco] = useState('');
    const [grauDeRiscoPgr, setGrauDeRiscoPgr] = useState('');
    const [nivelAcesso, setNivelAcesso] = useState(0);

    const location = useLocation();
    const showButton = location.pathname === '/vincular-tabelas' && !edit;

    useEffect(() => {
        if (riscoSelecionado) {
            setRisco(riscoSelecionado.risco ? riscoSelecionado.risco : riscoSelecionado.nome);
            setCategoria(riscoSelecionado.categoria);
            setFonteGeradora(riscoSelecionado.fonte_geradora);
            setPossiveisDanosASaude(riscoSelecionado.possiveis_danos_a_saude);
            setProbabilidade(riscoSelecionado.probabilidade);
            setSeveridade(riscoSelecionado.severidade);
            setProbabilidadePgr(riscoSelecionado.probabilidade_pgr);
            setSeveridadePgr(riscoSelecionado.severidade_pgr);
            setMedidasDeControleExistentes(riscoSelecionado.medidas_de_controle_existentes);
            setMedidasDeControlePropostas(riscoSelecionado.medidas_de_controle_propostas);
            setCronograma(riscoSelecionado.cronograma);
            setFormasDeAcompanhamento(riscoSelecionado.formas_de_acompanhamento);
            setAfericaoDosResultados(riscoSelecionado.afericao_dos_resultados);
            setMeiosPropagacao(riscoSelecionado.meio_de_propagacao);
            setFrequencia(riscoSelecionado.frequencia);
        }
    }, [riscoSelecionado]);

    useEffect(() => {
        if (riscoSelecionado && riscoSelecionado.id_risco_cadastrado) {
            api.post('get-quarentena-riscos-editados', riscoSelecionado).then((response: any) => {
                const riscosQuarentena = response.data.flat();
                setQuarentenaRiscosEditados(riscosQuarentena);
            });
        }
    }, [riscoSelecionado]);

    useEffect(() => {
        api.get('nivel-acesso').then((response: any) => {
            setNivelAcesso(response.data.nivel);
        });
    }, [])

    const getTextColor = (bgColor: string) => {
        const color = bgColor.charAt(0) == '#' ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.3 ? '#000000' : '#FFFFFF';
    };

    const getTooltip = (field: string) => {
        if (nivelAcesso === NiveisAcesso.ADMIN) {
            const change: any = quarentenaRiscosEditados.find((change: any) => change.coluna === field);
            return change ? `Valor antigo: ${JSON.parse(change.log).valor_antigo}, Valor atual: ${JSON.parse(change.log).valor_atual}` : '';
        }
    };

    const getClassName = (field: string) => {
        return (quarentenaRiscosEditados.some((change: any) => change.coluna === field) && nivelAcesso === NiveisAcesso.ADMIN) ? 'quarentena-error input' : 'input';
    };

    const textColor = getTextColor(headerColor);

    const calcularGrauDeRisco = (probabilidade: string, severidade: string) => {
        if (probabilidade == null || severidade == null) {
            return "";
        }

        const matrizRisco: any = {
            '4': { '1': 'Médio', '2': 'Médio', '3': 'Alto', '4': 'Muito alto' },
            '3': { '1': 'Médio', '2': 'Médio', '3': 'Alto', '4': 'Alto' },
            '2': { '1': 'Leve', '2': 'Médio', '3': 'Médio', '4': 'Alto' },
            '1': { '1': 'Leve', '2': 'Leve', '3': 'Médio', '4': 'Médio' }
        };

        const probMap: any = { 'Baixa': '1', 'Média': '2', 'Alta': '3', 'Muito Alta': '4' };
        const sevMap: any = { 'Baixa': '1', 'Média': '2', 'Alta': '3', 'Muito Alta': '4' };

        const p = probMap[probabilidade] || probabilidade.replace('P', '');
        const s = sevMap[severidade] || severidade.replace('P', '');

        return (p && s) ? matrizRisco[p][s] : '';
    };

    useEffect(() => {
        const grau = calcularGrauDeRisco(probabilidade, severidade);
        setGrauDeRisco(grau);
    }, [probabilidade, severidade]);

    useEffect(() => {
        const grauPgr = calcularGrauDeRisco(probabilidadePgr, severidadePgr);

        setGrauDeRiscoPgr(grauPgr);
    }, [probabilidadePgr, severidadePgr]);

    const clear = () => {
        setFonteGeradora('');
        setPossiveisDanosASaude('');
        setProbabilidade('');
        setSeveridade('');
        setProbabilidadePgr('');
        setSeveridadePgr('');
        setMedidasDeControleExistentes('');
        setMedidasDeControlePropostas('');
        setCronograma('');
        setFrequencia('');
        setFormasDeAcompanhamento('');
        setAfericaoDosResultados('');
        setMeiosPropagacao('');
    }

    const handleFormSubmit = async () => {
        try {
            const data = {
                id_base_risco: riscoSelecionado.id,
                tipo: type,
                tabelaSelecionada: tabelaSelecionada.id,
                categoria,
                risco,
                fonte_geradora: fonteGeradora,
                probabilidade,
                severidade,
                frequencia: frequencia,
                possiveis_danos_a_saude: possiveisDanosASaude,
                medidas_de_controle_propostas: medidasDeControlePropostas,
                medidas_de_controle_existentes: medidasDeControleExistentes,
                cronograma,
                formas_de_acompanhamento: formasDeAcompanhamento,
                afericao_dos_resultados: afericaoDosResultados,
                probabilidade_pgr: probabilidadePgr,
                severidade_pgr: severidadePgr,
                meio_de_propagacao: meiosPropagacao,
            };


            const response = await api.post('atualizar-risco', data);

            if (response.status == 200) {
                setAlert({ show: true, message: 'Risco atualizado com sucesso!', variant: 'success' });
                fetchRiscosPorTabela();
                clear();
            }

        } catch (error) {
            console.log(error)
        }
    };


    const handleSaveFormEdit = async () => {
        try {
            const data = {
                id: selectedRisco.id,
                tipo: type,
                id_base_risco: selectedRisco.id_risco ? selectedRisco.id_risco : selectedRisco.id_base_risco,
                categoria,
                risco,
                fonte_geradora: fonteGeradora,
                probabilidade,
                severidade,
                frequencia,
                possiveis_danos_a_saude: possiveisDanosASaude,
                medidas_de_controle_propostas: medidasDeControlePropostas,
                medidas_de_controle_existentes: medidasDeControleExistentes,
                cronograma,
                formas_de_acompanhamento: formasDeAcompanhamento,
                afericao_dos_resultados: afericaoDosResultados,
                probabilidade_pgr: probabilidadePgr,
                severidade_pgr: severidadePgr,
                meio_de_propagacao: meiosPropagacao,
            };

            if (selectedRisco.id_base_risco && selectedRisco.id_risco_cadastrado) {
                const response = await api.post(`editar-risco/${selectedRisco.id_empresa}/${selectedRisco.id_risco_cadastrado}`, data);

                if (response.status == 200) {
                    setAlert({ show: true, message: 'Risco atualizado com sucesso!', variant: 'success' });
                    setShowModal(false);
                }
            } else {
                const response = await api.post('editar-risco-tabela', data);

                if (response.status == 200) {
                    setAlert({ show: true, message: 'Risco atualizado com sucesso!', variant: 'success' });
                    fetchRiscosPorTabela();
                    setShowModal(false);
                }
            }
        } catch (error) {
            console.log(error)
        }
    };

    function mapearValorParaDescricao(valor: string) {
        if (valor == "Baixa") return '1';
        if (valor == "Média") return '2';
        if (valor == "Alta") return '3';
        if (valor == "Muito Alta") return '4';
        return "N/A";
    }

    function gerarGrauDeRisco(probabilidade: any, severidade: any): string {
        if (probabilidade == null || severidade == null) {
            return "Dados insuficientes";
        }

        const descricaoProbabilidade = mapearValorParaDescricao(probabilidade);
        const descricaoSeveridade = mapearValorParaDescricao(severidade);

        if (!descricaoProbabilidade || !descricaoSeveridade) {
            return "Valores não mapeáveis";
        }

        return `P${descricaoProbabilidade} x S${descricaoSeveridade}`;
    }

    const renderField = (value: any) => {
        return !value ? '-' : value;
    };

    return (
        <>
            {type == 1 ? (
                <div className='table-div risco' data-landscape="true">
                    <div className="table-tr inv-ris-plan-2">
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Inventário de Riscos</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Plano de Ação</div>
                    </div>
                    <div className="table-tr inv-props-2">
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Categoria</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Risco</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Fontes Geradoras</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Possíveis Danos a Saúde</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Grau de Risco (Intensidade)</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Risco Residual</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Medidas de Controle Propostas</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Cronograma</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Forma de Acompanhamento</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Aferição dos Resultados</div>
                    </div>
                    {riscos.length > 0 ? (
                        riscos.map((risco: any) => (
                            <div className="table-tr inv-props-2" key={risco.id}> {/* Certifique-se de que risco.id seja único */}
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.categoria ? risco.categoria : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.risco ? risco.risco : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.fonte_geradora ? risco.fonte_geradora : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.possiveis_danos_a_saude ? risco.possiveis_danos_a_saude : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.probabilidade && risco.severidade ? calcularGrauDeRisco(risco.probabilidade, risco.severidade) + ': ' + gerarGrauDeRisco(risco.probabilidade, risco.severidade) : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.probabilidade_pgr && risco.severidade_pgr ? calcularGrauDeRisco(risco.probabilidade_pgr, risco.severidade_pgr) + ': ' + risco.probabilidade_pgr + ' x ' + risco.severidade_pgr : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.medidas_de_controle_propostas ? risco.medidas_de_controle_propostas : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.cronograma ? risco.cronograma : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.formas_de_acompanhamento ? risco.formas_de_acompanhamento : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.afericao_dos_resultados ? risco.afericao_dos_resultados : '-'}</div>
                            </div>

                        ))
                    ) : (
                        <div className="table-tr inv-props-2">
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('categoria')}>
                                    <textarea className={getClassName('categoria')} style={{ overflow: 'hidden', textAlign: 'center' }} id="categoria" value={renderField(categoria)} onChange={(e) => setCategoria(e.target.value)} readOnly />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('risco')}>
                                    <textarea className={getClassName('risco')} style={{ overflow: 'hidden', textAlign: 'center' }} id="risco" value={renderField(risco)} onChange={(e) => setRisco(e.target.value)} readOnly />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('fonte_geradora')}>
                                    <textarea className={getClassName('fonte_geradora')} style={{ overflow: 'hidden', textAlign: 'center' }} id="fonte_geradora" value={renderField(fonteGeradora)} onChange={(e) => setFonteGeradora(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('possiveis_danos_a_saude')}>
                                    <textarea className={getClassName('possiveis_danos_a_saude')} style={{ overflow: 'hidden', textAlign: 'center' }} id="possiveis_danos_a_saude" value={renderField(possiveisDanosASaude)} onChange={(e) => setPossiveisDanosASaude(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td '>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <label style={{ textAlign: 'center' }}><b>Probabilidade</b></label>
                                    <Tooltip title={getTooltip('probabilidade')}>
                                        <select id="probabilidade" name="probabilidade" style={{ overflow: 'hidden' }} className={getClassName('probabilidade')} value={probabilidade} onChange={(e) => setProbabilidade(e.target.value)}>
                                            <option>Selecione</option>
                                            <option value="Muito Alta">Muito Alta (4)</option>
                                            <option value="Alta">Alta (3)</option>
                                            <option value="Média">Média (2)</option>
                                            <option value="Baixa">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                    <input type="text" readOnly value={renderField(grauDeRisco)} style={{ textAlign: 'center', width: '50px', margin: '5px' }} />
                                    <label style={{ textAlign: 'center' }}><b>Severidade</b></label>
                                    <Tooltip title={getTooltip('severidade')}>
                                        <select id="severidade" name="severidade" style={{ overflow: 'hidden' }} className={getClassName('severidade')} value={renderField(severidade)} onChange={(e) => setSeveridade(e.target.value)}>
                                            <option>Selecione</option>
                                            <option value="Muito Alta">Muito Alta (4)</option>
                                            <option value="Alta">Alta (3)</option>
                                            <option value="Média">Média (2)</option>
                                            <option value="Baixa">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                </div>


                            </div>
                            <div className='table-td '>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <label style={{ textAlign: 'center' }}><b>Probabilidade</b></label>
                                    <Tooltip title={getTooltip('probabilidadePgr')}>
                                        <select id="probabilidadePgr" name="probabilidadePgr" className={getClassName('probabilidadePgr')} style={{ overflow: 'hidden' }} value={renderField(probabilidadePgr)} onChange={(e) => setProbabilidadePgr(e.target.value)}>
                                            <option>Selecione</option>
                                            <option value="P4">Muito Alta (4)</option>
                                            <option value="P3">Alta (3)</option>
                                            <option value="P2">Média (2)</option>
                                            <option value="P1">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                    <input type="text" readOnly value={renderField(grauDeRiscoPgr)} style={{ textAlign: 'center', width: '50px', margin: '5px' }} />
                                    <label style={{ textAlign: 'center' }}><b>Severidade</b></label>
                                    <Tooltip title={getTooltip('severidadePgr')}>
                                        <select id="severidadePgr" name="severidadePgr" className={getClassName('severidadePgr')} style={{ overflow: 'hidden' }} value={renderField(severidadePgr)} onChange={(e) => setSeveridadePgr(e.target.value)}>
                                            <option>Selecione</option>
                                            <option value="P4">Muito Alta (4)</option>
                                            <option value="P3">Alta (3)</option>
                                            <option value="P2">Média (2)</option>
                                            <option value="P1">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('medidas_de_controle_propostas')}>
                                    <textarea className={getClassName('medidas_de_controle_propostas')} id="medidas_de_controle_propostas" style={{ overflow: 'hidden', textAlign: 'center' }} value={renderField(medidasDeControlePropostas)} onChange={(e) => setMedidasDeControlePropostas(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('cronograma')}>
                                    <textarea className={getClassName('cronograma')} id="cronograma" style={{ overflow: 'hidden', textAlign: 'center' }} value={renderField(cronograma)} onChange={(e) => setCronograma(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('formas_de_acompanhamento')}>
                                    <textarea className={getClassName('formas_de_acompanhamento')} id="formas_de_acompanhamento" style={{ overflow: 'hidden', textAlign: 'center' }} value={renderField(formasDeAcompanhamento)} onChange={(e) => setFormasDeAcompanhamento(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('afericao_dos_resultados')}>
                                    <textarea className={getClassName('afericao_dos_resultados')} id="afericao_dos_resultados" style={{ overflow: 'hidden', textAlign: 'center' }} value={renderField(afericaoDosResultados)} onChange={(e) => setAfericaoDosResultados(e.target.value)} />
                                </Tooltip>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className='table-div risco' data-landscape="true">
                    <div className="table-tr inv-ris-plan-1">
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Inventário de Riscos</div>
                    </div>
                    <div className="table-tr inv-props-1">
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Categoria</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Risco/Perigo</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Fontes Geradoras</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Meios de Propagação / Trajetória</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Frequência / Tipo de Exposição</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Possíveis Danos a Saúde</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Grau de Risco (Intensidade)</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Medidas de Controles Existentes</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Medidas de Controle Propostas</div>
                        <div className='table-td th' style={{ backgroundColor: headerColor, color: textColor }}>Risco Residual</div>
                    </div>
                    {riscos.length > 0 ? (
                        riscos.map((risco: any) => (
                            <div className="table-tr inv-props-1" key={risco.id}> {/* Certifique-se de que risco.id seja único */}
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.categoria ? risco.categoria : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.risco ? risco.risco : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.fonte_geradora ? risco.fonte_geradora : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.meio_de_propagacao ? risco.meio_de_propagacao : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.frequencia ? risco.frequencia : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.possiveis_danos_a_saude ? risco.possiveis_danos_a_saude : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.probabilidade && risco.severidade ? calcularGrauDeRisco(risco.probabilidade, risco.severidade) + ': ' + gerarGrauDeRisco(risco.probabilidade, risco.severidade) : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.medidas_de_controle_existentes ? risco.medidas_de_controle_existentes : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.medidas_de_controle_propostas ? risco.medidas_de_controle_propostas : '-'}</div>
                                <div className='table-td ' style={{ textAlign: 'center' }}>{risco.probabilidade_pgr && risco.severidade_pgr ? calcularGrauDeRisco(risco.probabilidade_pgr, risco.severidade_pgr) + ': ' + risco.probabilidade_pgr + ' x ' + risco.severidade_pgr : '-'}</div>
                            </div>
                        ))
                    ) : (
                        <div className="table-tr inv-props-1">
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('categoria')}>
                                    <textarea className={getClassName('categoria')} style={{ overflow: 'hidden', textAlign: 'center' }} id="categoria" value={renderField(categoria)} onChange={(e) => setCategoria(e.target.value)} readOnly />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('risco')}>
                                    <textarea className={getClassName('risco')} style={{ overflow: 'hidden', textAlign: 'center' }} id="risco" value={renderField(risco)} onChange={(e) => setRisco(e.target.value)} readOnly />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('fonte_geradora')}>
                                    <textarea className={getClassName('fonte_geradora')} style={{ overflow: 'hidden', textAlign: 'center' }} id="fonte_geradora" value={renderField(fonteGeradora)} onChange={(e) => setFonteGeradora(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('meios_propagacao')}>
                                    <textarea className={getClassName('meios_propagacao')} style={{ overflow: 'hidden', textAlign: 'center' }} id="meios_propagacao" value={renderField(meiosPropagacao)} onChange={(e) => setMeiosPropagacao(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('frequencia')}>
                                    <textarea className={getClassName('frequencia')} style={{ overflow: 'hidden', textAlign: 'center' }} id="frequencia" value={renderField(frequencia)} onChange={(e) => setFrequencia(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('possiveis_danos_a_saude')}>
                                    <textarea className={getClassName('possiveis_danos_a_saude')} style={{ overflow: 'hidden', textAlign: 'center' }} id="possiveis_danos_a_saude" value={renderField(possiveisDanosASaude)} onChange={(e) => setPossiveisDanosASaude(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td '>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <label style={{ textAlign: 'center' }}><b>Probabilidade</b></label>
                                    <Tooltip title={getTooltip('probabilidade')}>
                                        <select id="probabilidade" name="probabilidade" className={getClassName('probabilidade')} value={renderField(probabilidade)} onChange={(e) => setProbabilidade(e.target.value)} style={{ width: '80%', overflow: 'hidden' }}>
                                            <option>Selecione</option>
                                            <option value="Muito Alta">Muito Alta (4)</option>
                                            <option value="Alta">Alta (3)</option>
                                            <option value="Média">Média (2)</option>
                                            <option value="Baixa">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                    <input type="text" readOnly value={renderField(grauDeRisco)} style={{ textAlign: 'center', width: '50px', margin: '5px' }} />
                                    <label style={{ textAlign: 'center' }}><b>Severidade</b></label>
                                    <Tooltip title={getTooltip('severidade')}>
                                        <select id="severidade" name="severidade" className={getClassName('severidade')} value={renderField(severidade)} onChange={(e) => setSeveridade(e.target.value)} style={{ width: '80%', overflow: 'hidden' }}>
                                            <option>Selecione</option>
                                            <option value="Muito Alta">Muito Alta (4)</option>
                                            <option value="Alta">Alta (3)</option>
                                            <option value="Média">Média (2)</option>
                                            <option value="Baixa">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('medidas_de_controle_existentes')}>
                                    <textarea className={getClassName('medidas_de_controle_existentes')} style={{ overflow: 'hidden', textAlign: 'center' }} id="medidas_de_controle_existentes" value={renderField(medidasDeControleExistentes)} onChange={(e) => setMedidasDeControleExistentes(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td' style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title={getTooltip('medidas_de_controle_propostas')}>
                                    <textarea className={getClassName('medidas_de_controle_propostas')} style={{ overflow: 'hidden', textAlign: 'center' }} id="medidas_de_controle_propostas" value={renderField(medidasDeControlePropostas)} onChange={(e) => setMedidasDeControlePropostas(e.target.value)} />
                                </Tooltip>
                            </div>
                            <div className='table-td '>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <label style={{ textAlign: 'center' }}><b>Probabilidade</b></label>
                                    <Tooltip title={getTooltip('probabilidadePgr')}>
                                        <select id="probabilidadePgr" name="probabilidadePgr" className={getClassName('probabilidadePgr')} value={renderField(probabilidadePgr)} onChange={(e) => setProbabilidadePgr(e.target.value)} style={{ width: '90%', overflow: 'hidden' }}>
                                            <option>Selecione</option>
                                            <option value="P4">Muito Alta (4)</option>
                                            <option value="P3">Alta (3)</option>
                                            <option value="P2">Média (2)</option>
                                            <option value="P1">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                    <input type="text" readOnly value={renderField(grauDeRiscoPgr)} style={{ textAlign: 'center', width: '50px', margin: '5px' }} />
                                    <label style={{ textAlign: 'center' }}><b>Severidade</b></label>
                                    <Tooltip title={getTooltip('severidadePgr')}>
                                        <select id="severidadePgr" name="severidadePgr" className={getClassName('severidadePgr')} value={renderField(severidadePgr)} onChange={(e) => setSeveridadePgr(e.target.value)} style={{ width: '90%', overflow: 'hidden' }}>
                                            <option>Selecione</option>
                                            <option value="P4">Muito Alta (4)</option>
                                            <option value="P3">Alta (3)</option>
                                            <option value="P2">Média (2)</option>
                                            <option value="P1">Baixa (1)</option>
                                        </select>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            {showButton && (
                <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                    <Col md={2}>
                        <Button type="submit" style={{ width: '100%', backgroundColor: '#007AF3', color: 'white' }} onClick={handleFormSubmit}>
                            Inserir
                        </Button>
                    </Col>
                </Row>
            )}
            {selectedRisco && (edit == true) && (
                <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                    <Col md={2}>
                        <Button type="submit" style={{ width: '100%', backgroundColor: '#00CC00', color: 'white' }} onClick={handleSaveFormEdit}>
                            Salvar
                        </Button>
                    </Col>
                </Row>
            )}
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
};

export default DynamicTable;
